import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import { Stack, Typography } from "@mui/material";
import {
  BackArrowIcon,
  CloseDrawerIcon,
} from "../../components/ui-elements/svg-icons";
import { EyewitnessPost } from "../../interface/api";
import ReportOne from "../../components/posts/report-1";
import ReportTwo from "../../components/posts/report-2";
import ReportThree from "../../components/posts/report-3";
import ReportPreview from "../../components/posts/report-preview";
import useResponsive from "../../hooks/useResponsive";

const EyewitnessReport = ({
  open_report_modal,
  toggle_report_drawer,
  close_report_modal,
}: {
  open_report_modal: boolean;
  close_report_modal: () => void;
  toggle_report_drawer: (newOpen: boolean) => () => void;
}) => {
  const [page_number, setPage_number] = React.useState(1);
  const isSmall = useResponsive("down", "sm", "xl");
  const handle_next = () => {
    setPage_number(page_number + 1);
  };
  const handle_prev = () => {
    setPage_number(page_number - 1);
  };
  const [report_data, setReport_data] = React.useState<EyewitnessPost>({
    title: "",
    media: [],
    context: "",
    category: "",
    post_type: "eyewitness",
  });
  const set_page_default = () => setPage_number(1);
  const DrawerList = (
    <Box
      sx={{ width: isSmall ? "100%" : 500, mx: isSmall ? "auto" : "0px" }}
      role="presentation"
    >
      <Stack
        direction={"row"}
        alignItems="center"
        justifyContent={"space-between"}
        sx={{
          p: 2,
        }}
      >
        <Stack direction={"row"} alignItems={"center"} spacing={1}>
          {page_number === 4 && (
            <Button
              onClick={() => setPage_number(3)}
              sx={{ p: 0, m: 0, minWidth: 28 }}
            >
              <BackArrowIcon />
            </Button>
          )}
          <Typography variant="h4" color="black" sx={{ fontWeight: 600 }}>
            {page_number === 4 ? "Report preview" : "Eyewitness Report"}
          </Typography>
        </Stack>
        <Button onClick={toggle_report_drawer(false)}>
          <CloseDrawerIcon />
        </Button>
      </Stack>

      <Divider />
      <Box>
        {page_number === 1 && (
          <ReportOne
            cancel={toggle_report_drawer(false)}
            next={handle_next}
            report_data={report_data}
            setReport_data={setReport_data}
          />
        )}
        {page_number === 2 && (
          <ReportTwo
            prev={handle_prev}
            next={handle_next}
            report_data={report_data}
            setReport_data={setReport_data}
          />
        )}
        {page_number === 3 && (
          <ReportThree
            prev={handle_prev}
            next={handle_next}
            report_data={report_data}
            setReport_data={setReport_data}
          />
        )}
        {page_number === 4 && (
          <ReportPreview
            report_data={report_data}
            setReport_data={setReport_data}
            close_modal={close_report_modal}
            set_page_default={set_page_default}
          />
        )}
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        open={open_report_modal}
        onClose={toggle_report_drawer(false)}
        anchor="right"
      >
        {DrawerList}
      </Drawer>
    </div>
  );
};

export default EyewitnessReport;
